/** Created by Naveen on 24th Nov 2022
 * This file maintains the API response message and other constant values
 * Currently this file used only in @mp-fresh-case-component.ts file
 */

export const AADHAAR = "aadhaar";
export const ID = "id";
export const MOBILE_NUM_NTB = "mobileNoNTB";
export const AADHAAR_NUM_NTB = "aadhaarNTB";
export const MESSAGE_SUCCESS = "Success"
export const INVALID_OTP = "Invalid OTP";
export const OTP_EXPIRED = "OTP Expired";
export const MOBILE_NUM_INVALID = "Invalid mobile number";
export const MILE_STONE = {
    LOAN_REF: "loanRefNoGenerated",
    SATSURE_REPORT: "satsureReportGenerated",
    CROP_PATTERN:"cropPatternSubmitted",
    LOAN_AMOUNT:"loanAmountCalculated",
    DOCS_EXEC:"docsExecuted",
    DOCS_EXEC_REQ: "docsExecutedRequest"
};
export const TECH_ERROR ="Technical Error";
export const MESSAGE_FAILURE = "Failure";
export const MESSAGE_INVALID_REQUEST = "Invalid Request";
export const MESSAGE_NO_RES_UIADI = "No Response From UIDAI";
export const MESSAGE_OTP_NOT_GEN = "Could not generate and send OTP";
export const MESSAGE_EXISTING_CUST = "Failure as existing customer is from ETB";
export const MESSAGE_EXIST_KCC_LOAN = "ERR005 - Customer id has outstanding KCC Loan.";
export const MESSAGE_NPA_ACCOUNT = "ERR004 - Customer id has NPA Account.";
export const MESSAGE_DORMAT_ACCOUNT = "ERR054 - Customer having dormant saving accounts.";
export const MESSAGE_INVALID_AADHAR = "Invalid aadhaar number/Virtual Id";
export const MESSAGE_ALREADY_EXISTS = "Already exists";
export const MESSAGE_INVALID_MOB_NO  ="Invalid mobileNo";
export const MESSAGE_AADHAR_DOE_NOT_MATCH = "The entered Aadhaar Number and the Aadhaar number as per the Bank Records Do Not Match. Kindly Contact the Branch for the further process.";
export const MESAGE_MOBILE_NUM_NOT_FOUND = "Kindly contact your Branch and update your records to proceed further";
export const AGRI_NESL = "AGRL";
export const MESSAGE_INTERNAL_SERVER_ERRRO = "Internal Server Error";
export const MESSAGE_FINACLE_ERROR = "Finacle System Error Occoured!!! Please contact System Administrator.";
export const FRUITS_API_STATUS_TEXT = {
    FARMER_ID_NOT_FOUND: "Farmer Id Not exists",
    AADHAR_NOT_VALIDATED: "Aadhaar Not Validated"
};
export const STATE_LIST = {
   MP: 'Madhya Pradesh', 
   KA: 'Karnataka'
}
export const BRE_STATUS_DUPLICATE_ID = "Failed due to Duplicate Khasra No Entry"
export const DUPLI_KHASRA_FAIL = "Failed due to Duplicate Khasra No Entry"

export const MISSING_MESSAGE = {
    mobile:"Mobile number",
    mobile_hindi:"",
    name:"Applicant Name",
    name_hindi:"",
    sanctionedAmt:"Sanctioned Loan Amount",
    sanctionedAmt_hindi:"",
    referenceNo:"Loan Reference Number",
    referenceNo_hindi:""
}

export const VIEW_DETAILS = "View Details";
export const HIDE_DETAILS = "Hide Details";

export const STATES = {
    "MP": {
        "POSSIBILITIES": ["madya pradesh", "madhya pradesh", "mp", "madyapradesh", "madhyapradesh"],
        "ENABLED": true,
        "KEY":"xmpHUKBVNVSFG61XnJAzKOQ32EWjSdE1",
        "CODE":"MP"
    },
    "KA": {
        "POSSIBILITIES": ["ka", "kar", "karnataka"],
        "ENABLED": true,
        "KEY":"KDw2nS6vb5cJ286KJ3JwtGKGnnnLO93Y",
        "CODE":"KA"
    },
    "UP": {
        "POSSIBILITIES": ["up", "uttar pradesh","uttarpradesh"],
        "ENABLED": false,
        "KEY":"Uq4YVODcoCruRMHy8lCFRPFbAf8d4uP8",
        "CODE":"UP"
    },
    "MH": {
        "POSSIBILITIES": ["mh", "maharastra", "maha rastra", "maharashtra", "maha rashtra"],
        "ENABLED": true,
        "KEY":"fPWMHrmB1qRhPu2bOIT9LlGcAugp8cM6",
        "CODE":"MH"
    },
    "AD": {
        "POSSIBILITIES": ["ad", "andra", "andhara", "andra pradesh","andhra pradesh","ANDHRA PRADESH","ANDRA PRADESH","Andhra Pradesh","AD" ],
        "ENABLED": true,
        "CODE":"AD",
        "KEY":"X0ZUk5Z7otQSnJFm9rc2bcAvwPrp66i6"
    },
    "TL": {
        "POSSIBILITIES": ["telangana"],
        "ENABLED": true,
        "CODE":"TL"
    },
    "OD": {
        "POSSIBILITIES": ["od","odisha","orissa","Odisha","ORISSA","ODISHA","Odisha","OD"],
        "ENABLED": true,
        "KEY":"2HeSroDFbNjOyhnwVO4WV90Gu2ET1QsZ",
        "CODE":"OD"
    },
    "TN":{
        "POSSIBILITIES": ["tn","tamilnadu","tamil nadu","Tamil Nadu"],
        "ENABLED": true,
        "KEY":"tNteP4U71cOhlWNlpGF5F9vkWkUFtmMy",
        "CODE":"TN"
    },
    "RJ": {
        "POSSIBILITIES": ["rj", "rajasthan", "Rajasthan", "RAJASTHAN", "RJ","rajastan","RAJASTAN", "Rajastan"],
        "ENABLED": true,
        "CODE":"RJ",
        "KEY":"Rs3dWqiFcIvLvRNFneH8wSRduQF28UhJ"
    },
     "GJ": {
        "POSSIBILITIES": ["gj", "GJ", "Gj", "gujarat", "Gujarat", "GUJARAT", "gujrat", "Gujrat", "GUJRAT", "gujrat", "Gujrath", "GUJRATH", "Gujarath", "GUJARATH"],
        "ENABLED": true,
        "CODE":"GJ",
        "KEY":"gXpj9Y7qw1U5Jp6tdn4vkqduvnMZEjJJ"
    },
}

export const ROUTE_KEY = "wEnlw3OeU3";
export const PASSWORD_UPDATED_SUCCESSFULLY = "Password Updated Successfully";
export const PASSWORD_ALREADY_EXISTS = "Password Already exists.";
export const PASSWORD_PHRASE = "Password Should atleast be 8 characters length and should contain one special character, one lower case letter, one upper case letter and 1 digit";
export const PASSWORD_ENTERED_WRONG = "The current password you have entered is wrong.";
export const DYUWANNA_GEN_NOTHER_REPORT = "Do you want to generate another report?";
export const SOMETHING_WENT_WRONG = "OOPS!! Something went wrong";
export const USER_PROFILE_WILL_BE_CREATED_CONFIRM = "The request user profile will be created in the system. Do you confirm?"
export const REJECT_CREATION_REQST = "Do you confirm that you want to reject the user creation request?";
export const TRANSFER_REQ_DETAILS = "Transfer Request Details";
export const PROFILE_CREATED = "The user profile has been created successfully!";
export const USER_CREATION_REJECT = "The user creation request has been rejected.";
export const USER_PROFILE_TRANSFERED = "The user profile has been transfered successfully!";
export const TRANSFER_REQ_REJECTED = "User transfer Request has been rejected";
export const FAILED_TOFETCH_REPORT = "Failed to fetch the report. Please try again later.";
export const LAND_VERIFIED_SUCCESS = "Land details have been verified successfully.";
export const DYUWANNA_ADD_MORE_LANDS = "Do you want to add more land records?";
export const DOWNLOAD_DES = "Do you want to download the DES?";
export const FAILED_TO_SUBMIT_DATA = "Failed to submit data.";
export const FAILED_TO_GET_LOAN_INFORMATION = "Failed to get Loan Information.";
export const SENT_TOCBS_SUCCESS = "The case has been sent to CBS Successfully";
export const FAIL_TO_SENDCBS = "Failed to send to CBS. Please try again later";
export const CASE_REJECTED = "The case has been rejected Successfully.";
export const CASE_SHIFTED_TO_FAILUREBOX = "The case has been shifted to failure box. Do you want to stay on the page?";
export const REJECT_FAILED = "Failed update loan status. Please try again later";
export const NO_LAND_FOUND = "No Land Information found.";
export const UNABLE_TO_FETCH_CONSENTDATA = "Unable to fetch consent form data";
export const FAILED_IN_BRE = "Failed in BRE check.";
export const LR_UPD_PENDING = "Land record updation pending. Please add land records and click on Submit.";
export const PLS_FILL_LAND = "Please fill the Land Details for the customer.";
export const LANDS_FETCH_API_FAIL = "Failed to fetch land records information.";
export const NO_ADDED_LRS="No added land records found";
export const NO_KHARIF = "No kharif crops found";
export const NO_RABI = "No Rabi crops found";
export const DIST_INFO_MISSING = "Couldn't find District Information to get crops list";
export const FAILED_TO_FETCH_CROPS = "Failed to fetch Crops";
export const PLS_SUBMIT_CONSENT_FORM = "Please submit the consent form";
export const APPLI_DATA_NOT_FOUND = "Applicant data not found.";
export const APPL_DATA_FETCH_FAILS = "Failed to fetch details. Please try again later";
export const CREDIT_CHECK_FAIL = "Failed in credit check";
export const OVERALL_STATUS_FETCH_FAILED = "Failed to fetch overall status and credit data";
export const NPA_FOUND = "NPA Status Found.";
export const MOVED_TO_FAILUREBX = "The customer file has been moved to Failure Box."
export const PLS_GENERATED_CREDIT = "Please generate credit bureau for the customer.";
export const FAILED_BRE_FETCH = "Failed to fetch BRE information";
export const ASS_FAILURE_MOVED_TO_FAILURE = "Assessment failure. Moved to failure box.";
export const CONSENT_UPD_FAILURE = "Failed to update consent form.Please try again later.";
export const SAME_CROP_CANT_ADD = "Same crop cannot be added in the same season.";
export const CIF_ID_CREATED = "CIF ID created successfully.";
export const CIF_CREATE_FAILED = "Unable to create CIF ID, Please try later";
